<mat-expansion-panel #accordinPanel="matExpansionPanel" hideToggle class="mb-15" [disabled]="!itemsData || itemsData.length === 0">
    <mat-expansion-panel-header [class.border-b-g]="accordinPanel.expanded" [class.light-yellow]="!allItemsDealtWith() && itemsData.length">
        <mat-panel-title>
            <span class="flex align-center gap-10 pl-15">
                <i [class]="'accordin-icon uil '+ iconName"></i>
                <span class="badge" [ngClass]="getBadgeClass()">{{itemsData.length}}</span>
                <span>{{(type==='context_items'?'Context items':type) | capitaliz}}</span>
            </span>
        </mat-panel-title>
        <mat-panel-description>
            <span class="arrow-icon-grp flex align-center gap-6">
                <span class="flex align-center justify-center head-fill-tick" *ngIf="allItemsDealtWith()">
                    <i class="uil uil-check"></i>
                </span>
                <i class="uil uil-angle-down parent-arrow-down" *ngIf="!accordinPanel.expanded"></i>
                <i class="uil uil-angle-up parent-arrow-up" *ngIf="accordinPanel.expanded"></i>
            </span>
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div data-cy="generic-iq-analysis-summary-accordin__page" class="full-width">
        <div *ngFor="let item of itemsData; let i = index" [class.border-b-g]="expandedItems[i]">
            <!-- Header Row -->
            <div class="px-15 py-20 flex justify-btw full-width align-center" [class.border-b-g]="!expandedItems[i]">
                <span class="flex gap-5 align-center chip-badge" [ngClass]="{'yellow': item.status===null}">
                    <span class="fs-12 px-0 py-0">{{ formatText(item.name ? item.name : item.text ? item.text : item.description ? item.description : '') }}</span>
                    <span *ngIf="item.status === 'accepted'" class="fill-tick-badge flex align-center justify-center">
                        <i class="uil uil-check ts-14"></i>
                    </span>
                    <!-- Action icons for undecided items -->
                    <ng-container *ngIf="!item.status">
                        <i data-cy="generic-iq-analysis-summary-accordin__update-item-status" class="uil uil-check-circle clr-generic" (click)="updateItemStatus(i, 'accepted')"></i>
                        <i data-cy="generic-iq-analysis-summary-accordin__update-item-status-2" class="uil uil-times-circle clr-generic" (click)="updateItemStatus(i, 'declined')"></i>
                    </ng-container>
                </span>
                <span class="flex align-center gap-10">
                    <span class="clr-generic-child">{{'iq.analysis_labels.iq_details' | transloco}}</span>
                    <span data-cy="generic-iq-analysis-summary-accordin__toggle-item" class="star-badge small-badge d-cursor-hand" (click)="toggleItem(i)">
                        <i *ngIf="!expandedItems[i]" class="uil uil-angle-up child-arrow-up"></i>
                        <i *ngIf="expandedItems[i]" class="uil uil-angle-down child-arrow-up"></i>
                    </span>
                </span>
            </div>
            <!-- Expanded Content -->
            <div class="flex align-center gap-10 bg-bugandy radius-rounded mx-25 my-20 py-12 pl-12 pr-18" *ngIf="expandedItems[i]">
                <span class="star-badge animate-element">
                    <img src="../../../../../../assets/png/star.png" alt="Star">
                </span>
                <span class="sans-regular fc-black">
                    {{item.description}}
                </span>
            </div>
        </div>
        <!-- Footer Content -->
        <div class="px-15 py-20">
            <div class="gd-horizontal bg-bugandy radius-rounded px-12 py-12">
                <div class="flex align-center gap-10">
                    <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png"
                            alt="Star"></span>
                    <span class="sans-regular fc-black">{{'iq.analysis_labels.can_i_add_all_type' | transloco: { type: type } }}</span>
                </div>
                <mat-button-toggle-group data-cy="generic-iq-analysis-summary-accordin__political-toggle" name="politicalToggle" [hideSingleSelectionIndicator]="false" class="fit-content" (change)="updateAllItemsStatus($event.value)">
                    <mat-button-toggle value="accepted"><i class="uil uil-check-circle mr-3"></i>{{'iq.analysis_labels.accept' | transloco}}</mat-button-toggle>
                    <mat-button-toggle value="declined"><i class="uil uil-times-circle"></i>{{'iq.analysis_labels.decline' | transloco}}</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>
</mat-expansion-panel>